import { Box, Grid, IconButton, Tooltip } from '@mui/material'
import React from 'react'
// import AuthWrapper1 from 'ui-components/AuthWrapper1'
import CustomBackgroundComponent from 'ui-components/CustomBackgroundComponent'
import AuthLogin from 'views/pages/AuthLogin'
import { useTheme } from '@emotion/react'
import { Logout } from '@mui/icons-material'
import Cookies from 'js-cookie'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RESET_STATE } from 'store/actions'
import BannerImage from "assets/backrr_investor_banner.webp"
import { checkForAuthorization } from 'utils/index'


const OnboardingLayout = ({ children }) => {
    const theme = useTheme()
    // const navigate = useNavigate()
    // const dispatch = useDispatch()
    // const currentIP = window.location.host;
    return (
        <Grid xs={12} container sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", height: {xs: "100dvh", md: "100dvh"}, backgroundColor: theme.palette.customColors.yellow_bg }}>
            <Box className="container" sx={{ padding: { xs: "0 !important", md: "1rem !important", lg: "1rem !important" }, maxHeight: { xs: "100%", md: 600, lg: 730 } }}>
                <div class="form-section">
                    {children}
                </div>
                <Grid
                    item xs={12} md={6}
                    sx={{ display: 'flex', justifyContent: 'center' }}
                    className='illustration-section'
                >
                    <img
                        src={BannerImage}
                        alt="Backrr Investor Banner"
                    />
                </Grid>

            </Box>
        </Grid>
    )
}

export default OnboardingLayout